import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3.427 3.92a.7.7 0 0 1 .7-.7h15.746a.7.7 0 0 1 .7.7v16.16a.7.7 0 0 1-.7.7H4.127a.7.7 0 0 1-.7-.7V3.92Zm1.4.7v3.637h14.346V4.62H4.827Zm14.346 5.037H9.736v4.685h9.437V9.657Zm0 6.085H9.736v3.639h9.437v-3.639ZM8.336 19.381V9.657h-3.51v9.724h3.51Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
